<template>
<div>
    <!-- modal -->
    <b-modal id="lawTradeFairFormModal" centered size="lg" no-close-on-backdrop ref="lawTradeFairFormModal" :title=" $t('lawTradeFair.info')" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
        <validation-observer ref="simpleRules">
            <b-row>
                <b-col class="col-lg-6">
                    <b-form>
                        <label for="law-trade-fair-name-input">{{ $t('lawTradeFair.name') }}</label>
                        <b-form-group>
                            <validation-provider #default="{ errors }" :name=" $t('lawTradeFair.name')" rules="required">
                                <b-form-input id="law-trade-fair-name-input" v-model="name" size="sm" maxlength="100" :state="errors.length > 0 ? false:null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-3">
                    <b-form>
                        <label for="law-trade-fair-subject-input">{{ $t('lawTradeFair.law_trade_fair_subject') }}</label>
                        <b-form-group>
                            <b-form-select id="law-trade-fair-subject-input" size="sm" v-model="lawTradeFairSubjectSelect" value-field="id" text-field="name" :options="lawTradeFairSubjectOption" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-3">
                    <b-form>
                        <label for="law-trade-fair-center-input">{{ $t('lawTradeFair.law_trade_fair_center') }}</label>
                        <b-form-group>
                            <b-form-select id="law-trade-fair-center-input" size="sm" v-model="lawTradeFairCenterSelect" value-field="id" text-field="name" :options="lawTradeFairCenterOption" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
        </validation-observer>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getLawTradeFairList: {
            type: Function
        },
    },
    data() {
        return {
            id: 0,
            name: '',
            lawTradeFairSubjectSelect: 0,
            lawTradeFairSubjectOption: [],
            lawTradeFairCenterSelect: 0,
            lawTradeFairCenterOption: [],
        }
    },
    methods: {
        async showInfo(id) {
            this.$refs['lawTradeFairFormModal'].show()
            this.id = id
            const data = {
                id: this.id
            }
            const controller = {
                name: 'LawTradeFair'
            }
            const payload = {
                data: data,
                controller: controller
            }
            const response = await this.$store.dispatch('moduleAuth/getInfo', payload)
                if (response.data.resultStatus == true) {
                    this.name = response.data.lawTradeFair.name

                    this.lawTradeFairSubjectOption = response.data.lawTradeFairSubjectList
                    if (this.lawTradeFairSubjectOption != null) {
                        this.lawTradeFairSubjectOption.splice(0, 0, this.$nullSelected())
                    }
                    this.lawTradeFairSubjectSelect = response.data.lawTradeFair.lawTradeFairSubjectId

                    this.lawTradeFairCenterOption = response.data.lawTradeFairCenterList
                    if (this.lawTradeFairCenterOption != null) {
                        this.lawTradeFairCenterOption.splice(0, 0, this.$nullSelected())
                    }
                    this.lawTradeFairCenterSelect = response.data.lawTradeFair.lawTradeFairCenterId
                } else {
                    this.$bvModal.hide('lawTradeFairFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
        },
        async addOrUpdate() {
            const data = {
                id: this.id,
                name: this.name,
                lawTradeFairSubjectId: this.lawTradeFairSubjectSelect,
                lawTradeFairCenterId: this.lawTradeFairCenterSelect,
            }
            const controller = {
                name: 'LawTradeFair'
            }
            const payload = {
                data: data,
                controller: controller
            }
            const success = await this.$refs.simpleRules.validate()
                if (success) {
                    const response = await this.$store.dispatch('moduleAuth/save', payload)
                        if (response.data.resultStatus == true) {
                            this.$bvModal.hide('lawTradeFairFormModal')
                            this.getLawTradeFairList()
                            this.$SaveAlert()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                }
        },
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>
